<template>
	<div>
		<avatar :model="model" class="cursor-pointer flex items-center min-h-96" :size="size" color="transparent" @click="handleAvatarClick" :round="round" immediate>
			<overlay v-if="isLoading" :value="isLoading" absolute center :opacity="0.7">
				<loading-icon color="white"/>
			</overlay>
		</avatar>

		<client-only>
			<lazy-image-modal v-if="model.avatar" v-model="isActive" :src="[{path: model.avatar}]">
				<span></span>
				<template #button>
					<btn v-if="editable" @click="editAvatar" :loading="isLoading">
						<icon :icon="icons.edit"/>
						<span>{{ $t('action.edit') }}</span>
					</btn>
				</template>
			</lazy-image-modal>
		</client-only>

		<client-only v-if="editable">
			<lazy-image-cropper-modal v-model="showEditAvatarModal" :title="$t('action.edit_avatar')" :action="avatarUpdateAction"
									  :src="model.avatar ? model.avatar : model.avatar_selected"
									  :thumbnail="model.avatar ? model.avatar_thumbnail : null" help-size="500x500px" help-ratio="1/1"
									  name="avatar"
									  with-thumbnail
									  @success="avatarUpdated" :avatar="model.model_name === 'user'"/>

		</client-only>
	</div>
</template>

<script>
import {Toggleable} from "@spoferan/nuxt-spoferan/mixins";
import {editIcon} from "@spoferan/nuxt-spoferan/icons";
import {NativeApp} from "@spoferan/nuxt-spoferan/services";

export default {
	name: "ProfileAvatar",

	emits: ['updated'],

	mixins: [Toggleable],

	props: {
		model: {
			type: Object,
			required: true
		},

		// Whether the click actions can only be triggered by code and not by user actions
		passive: {
			type: Boolean,
			default: false
		},

		// Whether the avatar can be changed
		editable: {
			type: Boolean,
			default: false
		},

		round: {
			type: Boolean,
			default: false
		},

		size: {
			type: Number,
			default: 112
		},

		updateUrl: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			showEditAvatarModal: false,
			isLoading: false,

			icons: {
				edit: editIcon,
			}
		}
	},

	computed: {
		avatarUpdateAction() {
			return this.updateUrl ?? this.$api(this.model.model_name + 's.update', this.model._key);
		}
	},

	watch: {
		showEditAvatarModal(val) {
			if (val) {
				this.isActive = false;
			}
		}
	},

	methods: {
		avatarUpdated(modelWithNewAvatar) {
			this.showEditAvatarModal = false;
			this.$emit('updated', modelWithNewAvatar)
		},

		handleAvatarClick() {
			if (this.passive) {
				return;
			}
			if (this.model.avatar) {
				this.isActive = true;
			} else if (this.editable) {
				this.editAvatar();
			}
		},

		async editAvatar() {
			const nativeOptions = {
				crop: true,
				ratio: '1/1',
				action: this.avatarUpdateAction,
				method: 'PUT',
				name: 'avatar',
				auth: this.$auth.bearerToken
			};

			// window.native_X calls are removed for native apps with version >= 2.0.0
			if (window.native_image_picker) {
				window.native_image_picker_uploading = (loading) => {
					this.isActive = false
					this.isLoading = loading;
				}
				window.native_image_picker_callback = (modelWithNewAvatar) => {
					this.isActive = false
					this.isLoading = false;
					this.$emit('updated', modelWithNewAvatar)
				}
				window.native_image_picker.postMessage(JSON.stringify(nativeOptions));
			} else if (NativeApp.isNativeAppV2()) {
				this.isActive = false
				this.isLoading = true;
				try {
					const modelWithNewAvatar = await NativeApp.uploadImage(nativeOptions);
					this.$emit('updated', modelWithNewAvatar)
				} finally {
					this.isLoading = false;
				}
			} else {
				this.showEditAvatarModal = true;
			}
		}
	}
}
</script>